import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <div className="bg-white border-2 border-brand-purple rounded-3xl p-8 md:p-12 text-center shadow-xl relative overflow-hidden" data-id="element-79">
          {/* Decorative background element */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-brand-purpleLight -z-10" data-id="element-80"></div>

          <div className="bg-brand-purple text-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-81">
            <ShieldCheck className="w-10 h-10" data-id="element-82" />
          </div>

          <h2 className="text-3xl font-serif font-bold text-brand-darkGray mb-6" data-id="element-83">
            Garantía de 5 días sin preguntas
          </h2>

          <p className="text-lg text-brand-mediumGray font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-84">
            Si lo descargás, lo revisás y sentís que no era lo que esperabas, te
            devolvemos el dinero. Sin vueltas.{' '}
            <span className="text-brand-purpleDark font-bold" data-id="element-85">
              El riesgo es 100% nuestro.
            </span>
          </p>
        </div>
      </div>
    </section>;
}